import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import {webapi} from '../../../shared/my-constants';

@Injectable()
export class OpdPatientConfigService {

  private headers = new Headers({ 'Content-Type': 'application/json' });
  private AddRecord = webapi + 'opdpatientconfig/saveConfig';
  private ListRecord = webapi + 'opdpatientconfig/listByUnitId?';
  private GetRecord = webapi + 'opdpatientconfig/listbyConfigId/';
  private DeleteRecord = webapi + 'opdpatientconfig/delete/';
  private CheckRecordById= webapi + 'opdpatientconfig/checkById/';
  private RecordByUnitId = webapi + 'opdpatientconfig/recordByUnitId/';

  constructor(private http: Http) { }

  addRecordService(model: any) {
    // console.log(JSON.stringify(model));
    return this.http.post(this.AddRecord, JSON.stringify(model), { headers: this.headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any, unitId: any): Promise<any> {
     // console.log(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId);
    return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + qString + '&sort=' + sort + '&col=' + col + '&unitId=' + unitId )
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }


  getRecordService(id: any) {
    return this.http.get(this.GetRecord + id)
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }

  checkRecordExitForUnit(id: any) {
    return this.http.put(this.CheckRecordById + id, { headers: this.headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);

  }

  deleteRecordService(id: any) {

    return this.http.put(this.DeleteRecord + id, { headers: this.headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);

  }


  getRecordByUnitId(id: any ) {
    return this.http.put(this.RecordByUnitId + id, { headers: this.headers })
      .toPromise()
      .then(response => response.json())
      .catch(this.handleError);
  }


  private handleError(error: Response | any) {
    return Promise.reject(error.message || error);
  }

}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/application-configuration/opd-patient-config/opd-patient-config.service.ts